import React from 'react';
import { Icon } from '@iconify/react';

function SearchForm() {
	return (
		<div className="menu-item menu-item-form">
			<form action="" method="POST" name="search">
				<input type="text" className="form-control" placeholder="Type to search..." />
				<button type="submit" className="btn btn-search" aria-label="Search"><Icon icon="octicon:search-16" /></button>
			</form>
		</div>
	);
};

export default SearchForm;
